import {createAction} from "redux-actions";
import * as errorsFormTypes from "./errorsFormTypes";

export const handleFieldStatusUpdate = createAction(errorsFormTypes.HANDLE_FIELD_STATUS_UPDATE);
export const updateFieldStatus = createAction(errorsFormTypes.UPDATE_FIELD_STATUS);
